import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log para diagnóstico si un render vuelve a fallar en producción
    console.error("LeadFlow.WA render error:", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error-boundary" className="min-h-screen bg-[#0B0F14] flex items-center justify-center p-6">
          <div className="max-w-lg w-full bg-[#111822] border border-[#1E2D3D] rounded-2xl p-8 text-center">
            <h1 className="font-heading text-2xl font-extrabold text-slate-50 mb-2">Algo salió mal</h1>
            <p className="text-slate-400 text-sm mb-4">
              Ocurrió un error inesperado en la interfaz. Puedes recargar para continuar.
            </p>
            <pre className="text-left text-xs text-red-300 bg-[#0B0F14] border border-[#1E2D3D] rounded-lg p-3 overflow-auto max-h-40 mb-5 whitespace-pre-wrap break-words">
              {String(this.state.error?.message || this.state.error || "Error desconocido")}
            </pre>
            <button
              data-testid="error-reload-button"
              onClick={this.handleReload}
              className="h-11 px-6 rounded-lg bg-[#25D366] hover:bg-[#22BF5B] text-[#0B0F14] font-semibold transition-colors"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
